import { createGeneratePath } from '@itandi/tools/vanilla';

export const generatePath = createGeneratePath<
  | '/deals/:id'
  | '/deals/:deal_id/deal_todos'
  | 'deals/:deal_id/related_deals'
  | 'admin/deals/:deal_id/revert_status'
  | '/staffs'
  | '/staffs/:id'
  | '/staffs/:id/update_enabled'
  | '/staffs/login'
  | '/staffs/logout'
  | '/settings/company_construction_items'
  | '/company_construction_items'
  | '/company_construction_items/update_seq'
  | '/company_construction_items/:id/update_enabled'
  | '/vendors/vendor_company_password_resets'
  | '/vendors/deals/:id'
  | '/vendors/login'
  | '/deal_construction_items'
  | '/vendors/deals/:deal_id/deal_construction_items'
  | '/vendors/deals/:deal_id/deal_estimation_histories'
  | '/vendors/deals/:deal_id/deal_estimation_histories/:id'
  | '/vendors/deals/:deal_id/deal_estimation_histories/update_seq'
  | '/deals/:deal_id/deal_estimation_histories'
  | '/deals/:deal_id/deal_estimation_histories/:id'
  | '/deals/:deal_id/deal_estimation_histories/update_seq'
  | '/deals/:deal_id/deal_own_estimations'
  | '/deals/:deal_id/deal_own_estimations/:id'
  | '/deals/:deal_id/deal_own_estimations/update_seq'
  | '/deals/:deal_id/deal_billings'
  | '/deals/:deal_id/deal_billings/:id'
  | '/deals/:deal_id/deal_billings/update_seq'
  | '/vendors/sessions'
  | '/deals/:deal_id/deal_inspection_report_images'
  | '/deals/:deal_id/deal_completion_report_images'
  | '/vendors/deals/:deal_id/deal_inspection_report_images'
  | '/vendors/deals/:deal_id/deal_completion_report_images'
  | '/vendors/deals/:deal_id/deal_estimation_headers/update_note'
  | '/vendors/deals/:id/deal_estimation_histories'
  | '/vendors/construction_item_settings'
  | '/api/deals/:deal_id/deal_inspection_reports'
  | '/api/deals/:deal_id/deal_completion_reports'
  | '/api/vendors/deals/:deal_id/deal_inspection_reports'
  | '/api/vendors/deals/:deal_id/deal_completion_reports'
>();
